export const enum BridgingPersonalGuaranteeLevelEnum {
  None = 0,
  OneToTwentyFivePercent = 1,
  TwentySixToFiftyPercent = 2,
  FiftyOneToOneHundredPercent = 3,
}
